export default class ProductsNoBase {
    constructor() {
        this.init = this.init.bind(this);

        this.init();
        this.watchBaseButton();
    }
    async init() {
        try {
            await this.waitForPageLoad();
            this.watchBaseButton();
        } catch (error) {
            console.warn('Error waiting for page load', error);
        }
    }
    // Will wait for the add basket button to load.
    waitForPageLoad() {
        return new Promise((resolve, reject) => {
            const anchor = document.querySelector('article.product');

            if (!anchor) {
                reject('Anchor not found');
                return;
            }

            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.target.matches('.soap-product-selector')) {
                        observer.disconnect(); // Stop observing once the target is found
                        resolve(mutation); // Resolve the promise with the mutation data
                        return;
                    }
                }
            });

            observer.observe(anchor, { childList: true, subtree: true });
        });
    }

    watchBaseButton() {
        const baseRow = Array.from(document.querySelectorAll('.soap-product-selector form > div')).filter(row => {
            const label = row.querySelector('.soap-product-selector__dropdown__label');
            if (!label) return false;
            if (label.textContent.toLowerCase().includes('base')) return row;
        });

        if (baseRow.length === 0) return;
        const baseButton = baseRow[0];

        baseButton.querySelectorAll('.modal .item').forEach(item => {
            const caption = item.querySelector('.caption');
            if (!caption || !caption.textContent.trim().toLowerCase().includes('no base')) return;

            caption.insertAdjacentHTML('beforeend', '**');
        });

        const button = baseButton.querySelector('.modal .btn');
        if (!button) return;

        const buttonContainer = button.closest('.flex');
        if (!buttonContainer) return;

        buttonContainer.classList.add('flex-col');
        buttonContainer.style.alignItems = 'center';

        button.parentElement.insertAdjacentHTML('afterbegin', '<p class="text-center" style="margin-bottom:20px">** John Ryan mattresses are compatible with bases not purchased from John Ryan.</p>');
    }
}

if (document.querySelector('article.product')) new ProductsNoBase();
